module.exports = __webpack_public_path__ + "img/stel-logo-white.c790a8da.png";